import { createFileRoute } from '@tanstack/react-router';

import { PublicSupplierPage } from '@/features/marketplace/public-supplier-page';

export const Route = createFileRoute('/_app/marketplace/suppliers/$orgId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <PublicSupplierPage {...params} />;
}
